module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4jIOn"))).then(() => parcelRequire('37nVf'));